export default __webpack_public_path__ + "static/media/restroom.acfddd83.png";